import React, { useState } from 'react';
import { Divider, PageHeader, Tabs, Tooltip, Avatar } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import UpcomingPayments from './UpcomingPayments';
import CompletedPayments from './CompletedPayments';
import NotificationsPanel from 'containers/NotificationsPanel';

const Payments = () => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);

  const tabItems = [
    // remember to pass the key prop
    {
      label: 'Upcoming',
      key: 'upcoming-payments',
      children: <UpcomingPayments tab={tab} />,
    },
    {
      label: 'Completed',
      key: 'completed-payments',
      children: <CompletedPayments tab={tab} />,
    },
  ];

  const hideNotification = () => {
    setShowNotification(!showNotification);
  };

  return (
    <div className="app-container">
      <PageHeader
        onBack={() => null}
        backIcon={null}
        title={
          <div className=".d-inline" style={{ marginLeft: '10 px' }}>
            Payments
          </div>
        }
        className="py-sm-4 page-header"
        extra={
          <Tooltip title="Notifications">
            <Avatar src={require('assets/images/notification.png')} size="small" className="cursor-pointer mx-2" onClick={() => setShowNotification(!showNotification)} />
          </Tooltip>
        }
      />

      <Tabs className="my-4" type="line" items={tabItems} defaultActiveKey={tab} onChange={(key) => navigate(`/payments/${key}`)} />

      <Divider />
      <NotificationsPanel visible={showNotification} close={hideNotification} />
    </div>
  );
};

export default Payments;
